export default {
  maxHeight: 250, // Threshold where the "read-more" button appears
  title: 'Character',
  type: 'character',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
        title: '',
        options: {
          readmore: {
            height: 250,
            labels: {
              more: 'readmore#more',
              less: 'readmore#less'
            }
          }
        }
      },
      {
        id: 'collection-toponimi',
        type: 'collection',
        grid: 3,
        title: 'resource#collection-toponimi'
      },
      {
        id: 'metadata-occurences',
        type: 'metadata',
        // grid: 1,
        title: 'resource#occurences',
        options: {
          readmore: {
            height: 250,
            labels: {
              more: 'readmore#more',
              less: 'readmore#less'
            }
          }
        }
      },
    ],
  },
};
